import { render } from "./SoDoChoManHinhNgang.vue?vue&type=template&id=0670c69d&scoped=true"
import script from "./SoDoChoManHinhNgang.vue?vue&type=script&lang=js"
export * from "./SoDoChoManHinhNgang.vue?vue&type=script&lang=js"

import "./SoDoChoManHinhNgang.vue?vue&type=style&index=0&id=0670c69d&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0670c69d"]])

export default __exports__